/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CustomerWorkbookNotificationOut } from '../models/CustomerWorkbookNotificationOut';
import type { NativeWorkbookReviewStatusIn } from '../models/NativeWorkbookReviewStatusIn';
import type { Paginated_WorkbookSummaryOut_ } from '../models/Paginated_WorkbookSummaryOut_';
import type { WorkbookAssignmentOut } from '../models/WorkbookAssignmentOut';
import type { WorkbookAssignmentUpdateIn } from '../models/WorkbookAssignmentUpdateIn';
import type { WorkbookChannelIdReviewOut } from '../models/WorkbookChannelIdReviewOut';
import type { WorkbookClassificationIn } from '../models/WorkbookClassificationIn';
import type { WorkbookCorrectionRenderIn } from '../models/WorkbookCorrectionRenderIn';
import type { WorkbookCorrectionResetIn } from '../models/WorkbookCorrectionResetIn';
import type { WorkbookCorrectionSaveIn } from '../models/WorkbookCorrectionSaveIn';
import type { WorkbookCustomerClaimOut } from '../models/WorkbookCustomerClaimOut';
import type { WorkbookCustomerClaimUpdateIn } from '../models/WorkbookCustomerClaimUpdateIn';
import type { WorkbookCustomerProgressOut } from '../models/WorkbookCustomerProgressOut';
import type { WorkbookCustomerProgressUpdateIn } from '../models/WorkbookCustomerProgressUpdateIn';
import type { WorkbookCustomerStatisticsOut } from '../models/WorkbookCustomerStatisticsOut';
import type { WorkbookDetailOut } from '../models/WorkbookDetailOut';
import type { WorkbookLifecycleRenameIn } from '../models/WorkbookLifecycleRenameIn';
import type { WorkbookNotificationContextOut } from '../models/WorkbookNotificationContextOut';
import type { WorkbookNotificationIn } from '../models/WorkbookNotificationIn';
import type { WorkbookPathAliasOut } from '../models/WorkbookPathAliasOut';
import type { WorkbookReviewerOut } from '../models/WorkbookReviewerOut';
import type { WorkbookReviewOut } from '../models/WorkbookReviewOut';
import type { WorkbookVerifiedRowsIn } from '../models/WorkbookVerifiedRowsIn';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class WorkbooksService {
    /**
     * List Workbooks
     * @returns Paginated_WorkbookSummaryOut_ Successful Response
     * @throws ApiError
     */
    public static listWorkbooksProjectsProjectIdWorkbooksGet({
        projectId,
        assignee = 'all',
        assigneeIds,
        includeUnassigned = false,
        review = 'all',
        customerStatus = 'all',
        scopeId,
        search = '',
        sort = '-created_at',
        page = 1,
        pageSize = 20,
    }: {
        projectId: number,
        assignee?: 'all' | 'mine' | 'unassigned',
        assigneeIds?: Array<string>,
        includeUnassigned?: boolean,
        review?: 'all' | 'needs_review' | 'ready_for_customer' | 'customer_visible',
        customerStatus?: 'all' | 'needs_review' | 'in_progress' | 'done',
        scopeId?: (string | null),
        search?: string,
        sort?: 'created_at' | '-created_at' | 'updated_at' | '-updated_at' | 'display_name' | '-display_name' | 'progress' | '-progress' | 'sent_to_customer' | '-sent_to_customer',
        page?: number,
        pageSize?: number,
    }): CancelablePromise<Paginated_WorkbookSummaryOut_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/projects/{project_id}/workbooks',
            path: {
                'project_id': projectId,
            },
            query: {
                'assignee': assignee,
                'assignee_ids': assigneeIds,
                'include_unassigned': includeUnassigned,
                'review': review,
                'customer_status': customerStatus,
                'scope_id': scopeId,
                'search': search,
                'sort': sort,
                'page': page,
                'page_size': pageSize,
            },
            errors: {
                401: `Authentication or a valid workbook content capability is required.`,
                403: `The workbook is not available to this user.`,
                404: `The workbook or target scope was not found.`,
                409: `The workbook content or lifecycle state conflicts with this request.`,
                410: `project_archived: the project is archived and workbook access is unavailable.`,
                422: `The workbook request is invalid.`,
                503: `Workbook storage is temporarily unavailable.`,
            },
        });
    }
    /**
     * List Workbook Customer Reviewers
     * @returns WorkbookReviewerOut Successful Response
     * @throws ApiError
     */
    public static listWorkbookCustomerReviewersProjectsProjectIdWorkbooksCustomerReviewersGet({
        projectId,
    }: {
        projectId: number,
    }): CancelablePromise<Array<WorkbookReviewerOut>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/projects/{project_id}/workbooks/customer-reviewers',
            path: {
                'project_id': projectId,
            },
            errors: {
                401: `Authentication or a valid workbook content capability is required.`,
                403: `The workbook is not available to this user.`,
                404: `The workbook or target scope was not found.`,
                409: `The workbook content or lifecycle state conflicts with this request.`,
                410: `project_archived: the project is archived and workbook access is unavailable.`,
                422: `The workbook request is invalid.`,
                503: `Workbook storage is temporarily unavailable.`,
            },
        });
    }
    /**
     * Customer Statistics
     * @returns WorkbookCustomerStatisticsOut Successful Response
     * @throws ApiError
     */
    public static customerStatisticsProjectsProjectIdWorkbooksCustomerStatisticsGet({
        projectId,
    }: {
        projectId: number,
    }): CancelablePromise<WorkbookCustomerStatisticsOut> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/projects/{project_id}/workbooks/customer-statistics',
            path: {
                'project_id': projectId,
            },
            errors: {
                401: `Authentication or a valid workbook content capability is required.`,
                403: `The workbook is not available to this user.`,
                404: `The workbook or target scope was not found.`,
                409: `The workbook content or lifecycle state conflicts with this request.`,
                410: `project_archived: the project is archived and workbook access is unavailable.`,
                422: `The workbook request is invalid.`,
                503: `Workbook storage is temporarily unavailable.`,
            },
        });
    }
    /**
     * Resolve Workbook Path
     * @returns WorkbookPathAliasOut Successful Response
     * @throws ApiError
     */
    public static resolveWorkbookPathProjectsProjectIdWorkbooksResolveGet({
        projectId,
        path,
    }: {
        projectId: number,
        path: string,
    }): CancelablePromise<WorkbookPathAliasOut> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/projects/{project_id}/workbooks/resolve',
            path: {
                'project_id': projectId,
            },
            query: {
                'path': path,
            },
            errors: {
                401: `Authentication or a valid workbook content capability is required.`,
                403: `The workbook is not available to this user.`,
                404: `The workbook or target scope was not found.`,
                409: `The workbook content or lifecycle state conflicts with this request.`,
                410: `project_archived: the project is archived and workbook access is unavailable.`,
                422: `The workbook request is invalid.`,
                503: `Workbook storage is temporarily unavailable.`,
            },
        });
    }
    /**
     * List Workbook Reviewers
     * @returns WorkbookReviewerOut Successful Response
     * @throws ApiError
     */
    public static listWorkbookReviewersProjectsProjectIdWorkbooksReviewersGet({
        projectId,
    }: {
        projectId: number,
    }): CancelablePromise<Array<WorkbookReviewerOut>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/projects/{project_id}/workbooks/reviewers',
            path: {
                'project_id': projectId,
            },
            errors: {
                401: `Authentication or a valid workbook content capability is required.`,
                403: `The workbook is not available to this user.`,
                404: `The workbook or target scope was not found.`,
                409: `The workbook content or lifecycle state conflicts with this request.`,
                410: `project_archived: the project is archived and workbook access is unavailable.`,
                422: `The workbook request is invalid.`,
                503: `Workbook storage is temporarily unavailable.`,
            },
        });
    }
    /**
     * @deprecated
     * Archive Workbook
     * @returns WorkbookDetailOut Successful Response
     * @throws ApiError
     */
    public static archiveWorkbookProjectsProjectIdWorkbooksWorkbookIdDelete({
        projectId,
        workbookId,
        expectedVersion,
    }: {
        projectId: number,
        workbookId: string,
        expectedVersion: number,
    }): CancelablePromise<WorkbookDetailOut> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/projects/{project_id}/workbooks/{workbook_id}',
            path: {
                'project_id': projectId,
                'workbook_id': workbookId,
            },
            query: {
                'expected_version': expectedVersion,
            },
            errors: {
                401: `Authentication or a valid workbook content capability is required.`,
                403: `The workbook is not available to this user.`,
                404: `The workbook or target scope was not found.`,
                409: `The workbook content or lifecycle state conflicts with this request.`,
                410: `project_archived: the project is archived and workbook access is unavailable.`,
                422: `The workbook request is invalid.`,
                503: `Workbook storage is temporarily unavailable.`,
            },
        });
    }
    /**
     * Get Workbook
     * @returns WorkbookDetailOut Successful Response
     * @throws ApiError
     */
    public static getWorkbookProjectsProjectIdWorkbooksWorkbookIdGet({
        projectId,
        workbookId,
    }: {
        projectId: number,
        workbookId: string,
    }): CancelablePromise<WorkbookDetailOut> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/projects/{project_id}/workbooks/{workbook_id}',
            path: {
                'project_id': projectId,
                'workbook_id': workbookId,
            },
            errors: {
                401: `Authentication or a valid workbook content capability is required.`,
                403: `The workbook is not available to this user.`,
                404: `The workbook or target scope was not found.`,
                409: `The workbook content or lifecycle state conflicts with this request.`,
                410: `project_archived: the project is archived and workbook access is unavailable.`,
                422: `The workbook request is invalid.`,
                503: `Workbook storage is temporarily unavailable.`,
            },
        });
    }
    /**
     * Update Workbook Assignment
     * @returns WorkbookAssignmentOut Successful Response
     * @throws ApiError
     */
    public static updateWorkbookAssignmentProjectsProjectIdWorkbooksWorkbookIdAssignmentPut({
        projectId,
        workbookId,
        requestBody,
    }: {
        projectId: number,
        workbookId: string,
        requestBody: WorkbookAssignmentUpdateIn,
    }): CancelablePromise<WorkbookAssignmentOut> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/projects/{project_id}/workbooks/{workbook_id}/assignment',
            path: {
                'project_id': projectId,
                'workbook_id': workbookId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Authentication or a valid workbook content capability is required.`,
                403: `The workbook is not available to this user.`,
                404: `The workbook or target scope was not found.`,
                409: `The workbook content or lifecycle state conflicts with this request.`,
                410: `project_archived: the project is archived and workbook access is unavailable.`,
                422: `The workbook request is invalid.`,
                503: `Workbook storage is temporarily unavailable.`,
            },
        });
    }
    /**
     * Get Workbook Channel Id Review
     * @returns WorkbookChannelIdReviewOut Successful Response
     * @throws ApiError
     */
    public static getWorkbookChannelIdReviewProjectsProjectIdWorkbooksWorkbookIdChannelIdReviewGet({
        projectId,
        workbookId,
        snapshotToken,
    }: {
        projectId: number,
        workbookId: string,
        snapshotToken: string,
    }): CancelablePromise<WorkbookChannelIdReviewOut> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/projects/{project_id}/workbooks/{workbook_id}/channel-id-review',
            path: {
                'project_id': projectId,
                'workbook_id': workbookId,
            },
            query: {
                'snapshot_token': snapshotToken,
            },
            errors: {
                401: `Authentication or a valid workbook content capability is required.`,
                403: `The workbook is not available to this user.`,
                404: `The workbook or target scope was not found.`,
                409: `The workbook content or lifecycle state conflicts with this request.`,
                410: `project_archived: the project is archived and workbook access is unavailable.`,
                422: `The workbook request is invalid.`,
                503: `Workbook storage is temporarily unavailable.`,
            },
        });
    }
    /**
     * Classify Workbook
     * @returns WorkbookDetailOut Successful Response
     * @throws ApiError
     */
    public static classifyWorkbookProjectsProjectIdWorkbooksWorkbookIdClassificationPut({
        projectId,
        workbookId,
        requestBody,
    }: {
        projectId: number,
        workbookId: string,
        requestBody: WorkbookClassificationIn,
    }): CancelablePromise<WorkbookDetailOut> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/projects/{project_id}/workbooks/{workbook_id}/classification',
            path: {
                'project_id': projectId,
                'workbook_id': workbookId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Authentication or a valid workbook content capability is required.`,
                403: `The workbook is not available to this user.`,
                404: `The workbook or target scope was not found.`,
                409: `The workbook content or lifecycle state conflicts with this request.`,
                410: `project_archived: the project is archived and workbook access is unavailable.`,
                422: `The workbook request is invalid.`,
                503: `Workbook storage is temporarily unavailable.`,
            },
        });
    }
    /**
     * Get Workbook Content
     * @returns binary Generation-pinned native workbook bytes.
     * @throws ApiError
     */
    public static getWorkbookContentProjectsProjectIdWorkbooksWorkbookIdContentGet({
        projectId,
        workbookId,
        snapshotToken,
        version = 'effective',
    }: {
        projectId: number,
        workbookId: string,
        snapshotToken: string,
        version?: 'original' | 'effective',
    }): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/projects/{project_id}/workbooks/{workbook_id}/content',
            path: {
                'project_id': projectId,
                'workbook_id': workbookId,
            },
            query: {
                'snapshot_token': snapshotToken,
                'version': version,
            },
            errors: {
                401: `Authentication or a valid workbook content capability is required.`,
                403: `The workbook is not available to this user.`,
                404: `The workbook or target scope was not found.`,
                409: `The workbook content or lifecycle state conflicts with this request.`,
                410: `project_archived: the project is archived and workbook access is unavailable.`,
                422: `The workbook request is invalid.`,
                503: `Workbook storage is temporarily unavailable.`,
            },
        });
    }
    /**
     * Save Workbook Correction
     * @returns WorkbookDetailOut Successful Response
     * @throws ApiError
     */
    public static saveWorkbookCorrectionProjectsProjectIdWorkbooksWorkbookIdCorrectionPut({
        projectId,
        workbookId,
        requestBody,
    }: {
        projectId: number,
        workbookId: string,
        requestBody: WorkbookCorrectionSaveIn,
    }): CancelablePromise<WorkbookDetailOut> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/projects/{project_id}/workbooks/{workbook_id}/correction',
            path: {
                'project_id': projectId,
                'workbook_id': workbookId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Authentication or a valid workbook content capability is required.`,
                403: `The workbook is not available to this user.`,
                404: `The workbook or target scope was not found.`,
                409: `The workbook content or lifecycle state conflicts with this request.`,
                410: `project_archived: the project is archived and workbook access is unavailable.`,
                422: `The workbook request is invalid.`,
                503: `Workbook storage is temporarily unavailable.`,
            },
        });
    }
    /**
     * Render Workbook Correction
     * @returns binary Rendered native workbook preview bytes.
     * @throws ApiError
     */
    public static renderWorkbookCorrectionProjectsProjectIdWorkbooksWorkbookIdCorrectionRenderPost({
        projectId,
        workbookId,
        requestBody,
    }: {
        projectId: number,
        workbookId: string,
        requestBody: WorkbookCorrectionRenderIn,
    }): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/projects/{project_id}/workbooks/{workbook_id}/correction:render',
            path: {
                'project_id': projectId,
                'workbook_id': workbookId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Authentication or a valid workbook content capability is required.`,
                403: `The workbook is not available to this user.`,
                404: `The workbook or target scope was not found.`,
                409: `The workbook content or lifecycle state conflicts with this request.`,
                410: `project_archived: the project is archived and workbook access is unavailable.`,
                422: `The workbook request is invalid.`,
                503: `Workbook storage is temporarily unavailable.`,
            },
        });
    }
    /**
     * Reset Workbook Correction
     * @returns WorkbookDetailOut Successful Response
     * @throws ApiError
     */
    public static resetWorkbookCorrectionProjectsProjectIdWorkbooksWorkbookIdCorrectionResetPost({
        projectId,
        workbookId,
        requestBody,
    }: {
        projectId: number,
        workbookId: string,
        requestBody: WorkbookCorrectionResetIn,
    }): CancelablePromise<WorkbookDetailOut> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/projects/{project_id}/workbooks/{workbook_id}/correction:reset',
            path: {
                'project_id': projectId,
                'workbook_id': workbookId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Authentication or a valid workbook content capability is required.`,
                403: `The workbook is not available to this user.`,
                404: `The workbook or target scope was not found.`,
                409: `The workbook content or lifecycle state conflicts with this request.`,
                410: `project_archived: the project is archived and workbook access is unavailable.`,
                422: `The workbook request is invalid.`,
                503: `Workbook storage is temporarily unavailable.`,
            },
        });
    }
    /**
     * Update Workbook Customer Claim
     * @returns WorkbookCustomerClaimOut Successful Response
     * @throws ApiError
     */
    public static updateWorkbookCustomerClaimProjectsProjectIdWorkbooksWorkbookIdCustomerClaimPut({
        projectId,
        workbookId,
        requestBody,
    }: {
        projectId: number,
        workbookId: string,
        requestBody: WorkbookCustomerClaimUpdateIn,
    }): CancelablePromise<WorkbookCustomerClaimOut> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/projects/{project_id}/workbooks/{workbook_id}/customer-claim',
            path: {
                'project_id': projectId,
                'workbook_id': workbookId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Authentication or a valid workbook content capability is required.`,
                403: `The workbook is not available to this user.`,
                404: `The workbook or target scope was not found.`,
                409: `The workbook content or lifecycle state conflicts with this request.`,
                410: `project_archived: the project is archived and workbook access is unavailable.`,
                422: `The workbook request is invalid.`,
                503: `Workbook storage is temporarily unavailable.`,
            },
        });
    }
    /**
     * Send Workbook Customer Notifications
     * @returns CustomerWorkbookNotificationOut Successful Response
     * @throws ApiError
     */
    public static sendWorkbookCustomerNotificationsProjectsProjectIdWorkbooksWorkbookIdCustomerNotificationsPost({
        projectId,
        workbookId,
        requestBody,
    }: {
        projectId: number,
        workbookId: string,
        requestBody: WorkbookNotificationIn,
    }): CancelablePromise<CustomerWorkbookNotificationOut> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/projects/{project_id}/workbooks/{workbook_id}/customer-notifications',
            path: {
                'project_id': projectId,
                'workbook_id': workbookId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Authentication or a valid workbook content capability is required.`,
                403: `The workbook is not available to this user.`,
                404: `The workbook or target scope was not found.`,
                409: `The workbook content or lifecycle state conflicts with this request.`,
                410: `project_archived: the project is archived and workbook access is unavailable.`,
                422: `The workbook request is invalid.`,
                503: `Workbook storage is temporarily unavailable.`,
            },
        });
    }
    /**
     * Update Customer Progress
     * @returns WorkbookCustomerProgressOut Successful Response
     * @throws ApiError
     */
    public static updateCustomerProgressProjectsProjectIdWorkbooksWorkbookIdCustomerProgressPut({
        projectId,
        workbookId,
        requestBody,
    }: {
        projectId: number,
        workbookId: string,
        requestBody: WorkbookCustomerProgressUpdateIn,
    }): CancelablePromise<WorkbookCustomerProgressOut> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/projects/{project_id}/workbooks/{workbook_id}/customer-progress',
            path: {
                'project_id': projectId,
                'workbook_id': workbookId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Authentication or a valid workbook content capability is required.`,
                403: `The workbook is not available to this user.`,
                404: `The workbook or target scope was not found.`,
                409: `The workbook content or lifecycle state conflicts with this request.`,
                410: `project_archived: the project is archived and workbook access is unavailable.`,
                422: `The workbook request is invalid.`,
                503: `Workbook storage is temporarily unavailable.`,
            },
        });
    }
    /**
     * Get Workbook Input Source Card
     * @returns binary Generation-pinned workbook source PDF.
     * @throws ApiError
     */
    public static getWorkbookInputSourceCardProjectsProjectIdWorkbooksWorkbookIdGenerationsGenerationIdInputsSourceFileVersionIdSourceCardGet({
        projectId,
        workbookId,
        generationId,
        sourceFileVersionId,
        expectedEffectiveContentHash,
    }: {
        projectId: number,
        workbookId: string,
        generationId: string,
        sourceFileVersionId: string,
        expectedEffectiveContentHash: string,
    }): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/projects/{project_id}/workbooks/{workbook_id}/generations/{generation_id}/inputs/{source_file_version_id}/source-card',
            path: {
                'project_id': projectId,
                'workbook_id': workbookId,
                'generation_id': generationId,
                'source_file_version_id': sourceFileVersionId,
            },
            query: {
                'expected_effective_content_hash': expectedEffectiveContentHash,
            },
            errors: {
                401: `Authentication is required.`,
                403: `The workbook identity is not released to the customer.`,
                404: `The workbook row or pinned source PDF was not found.`,
                409: `The workbook or source lineage changed.`,
                410: `project_archived: the project is archived and source-card access is unavailable.`,
                413: `The source PDF exceeds the browser review limit.`,
                422: `The request or pinned source content is invalid.`,
                503: `Source PDF storage is temporarily unavailable.`,
            },
        });
    }
    /**
     * Get Workbook Source Card
     * @returns binary Generation-pinned workbook source PDF.
     * @throws ApiError
     */
    public static getWorkbookSourceCardProjectsProjectIdWorkbooksWorkbookIdGenerationsGenerationIdRowsRowIdSourceCardGet({
        projectId,
        workbookId,
        generationId,
        rowId,
        expectedEffectiveContentHash,
    }: {
        projectId: number,
        workbookId: string,
        generationId: string,
        rowId: string,
        expectedEffectiveContentHash: string,
    }): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/projects/{project_id}/workbooks/{workbook_id}/generations/{generation_id}/rows/{row_id}/source-card',
            path: {
                'project_id': projectId,
                'workbook_id': workbookId,
                'generation_id': generationId,
                'row_id': rowId,
            },
            query: {
                'expected_effective_content_hash': expectedEffectiveContentHash,
            },
            errors: {
                401: `Authentication is required.`,
                403: `The workbook identity is not released to the customer.`,
                404: `The workbook row or pinned source PDF was not found.`,
                409: `The workbook or source lineage changed.`,
                410: `project_archived: the project is archived and source-card access is unavailable.`,
                413: `The source PDF exceeds the browser review limit.`,
                422: `The request or pinned source content is invalid.`,
                503: `Source PDF storage is temporarily unavailable.`,
            },
        });
    }
    /**
     * Archive Workbook Lifecycle
     * @returns WorkbookDetailOut Successful Response
     * @throws ApiError
     */
    public static archiveWorkbookLifecycleProjectsProjectIdWorkbooksWorkbookIdLifecycleDelete({
        projectId,
        workbookId,
        expectedVersion,
    }: {
        projectId: number,
        workbookId: string,
        expectedVersion: number,
    }): CancelablePromise<WorkbookDetailOut> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/projects/{project_id}/workbooks/{workbook_id}/lifecycle',
            path: {
                'project_id': projectId,
                'workbook_id': workbookId,
            },
            query: {
                'expected_version': expectedVersion,
            },
            errors: {
                401: `Authentication or a valid workbook content capability is required.`,
                403: `The workbook is not available to this user.`,
                404: `The workbook or target scope was not found.`,
                409: `The workbook content or lifecycle state conflicts with this request.`,
                410: `project_archived: the project is archived and workbook access is unavailable.`,
                422: `The workbook request is invalid.`,
                503: `Workbook storage is temporarily unavailable.`,
            },
        });
    }
    /**
     * Rename Workbook Lifecycle
     * @returns WorkbookDetailOut Successful Response
     * @throws ApiError
     */
    public static renameWorkbookLifecycleProjectsProjectIdWorkbooksWorkbookIdLifecyclePatch({
        projectId,
        workbookId,
        requestBody,
    }: {
        projectId: number,
        workbookId: string,
        requestBody: WorkbookLifecycleRenameIn,
    }): CancelablePromise<WorkbookDetailOut> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/projects/{project_id}/workbooks/{workbook_id}/lifecycle',
            path: {
                'project_id': projectId,
                'workbook_id': workbookId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Authentication or a valid workbook content capability is required.`,
                403: `The workbook is not available to this user.`,
                404: `The workbook or target scope was not found.`,
                409: `The workbook content or lifecycle state conflicts with this request.`,
                410: `project_archived: the project is archived and workbook access is unavailable.`,
                422: `The workbook request is invalid.`,
                503: `Workbook storage is temporarily unavailable.`,
            },
        });
    }
    /**
     * Get Workbook Notification Context
     * @returns WorkbookNotificationContextOut Successful Response
     * @throws ApiError
     */
    public static getWorkbookNotificationContextProjectsProjectIdWorkbooksWorkbookIdNotificationContextGet({
        projectId,
        workbookId,
    }: {
        projectId: number,
        workbookId: string,
    }): CancelablePromise<WorkbookNotificationContextOut> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/projects/{project_id}/workbooks/{workbook_id}/notification-context',
            path: {
                'project_id': projectId,
                'workbook_id': workbookId,
            },
            errors: {
                401: `Authentication or a valid workbook content capability is required.`,
                403: `The workbook is not available to this user.`,
                404: `The workbook or target scope was not found.`,
                409: `The workbook content or lifecycle state conflicts with this request.`,
                410: `project_archived: the project is archived and workbook access is unavailable.`,
                422: `The workbook request is invalid.`,
                503: `Workbook storage is temporarily unavailable.`,
            },
        });
    }
    /**
     * Get Workbook Review Status
     * @returns WorkbookReviewOut Successful Response
     * @throws ApiError
     */
    public static getWorkbookReviewStatusProjectsProjectIdWorkbooksWorkbookIdReviewStatusGet({
        projectId,
        workbookId,
        expectedGenerationId,
        expectedEffectiveHash,
    }: {
        projectId: number,
        workbookId: string,
        expectedGenerationId: string,
        expectedEffectiveHash: string,
    }): CancelablePromise<WorkbookReviewOut> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/projects/{project_id}/workbooks/{workbook_id}/review-status',
            path: {
                'project_id': projectId,
                'workbook_id': workbookId,
            },
            query: {
                'expected_generation_id': expectedGenerationId,
                'expected_effective_hash': expectedEffectiveHash,
            },
            errors: {
                401: `Authentication or a valid workbook content capability is required.`,
                403: `The workbook is not available to this user.`,
                404: `The workbook or target scope was not found.`,
                409: `The workbook content or lifecycle state conflicts with this request.`,
                410: `project_archived: the project is archived and workbook access is unavailable.`,
                422: `The workbook request is invalid.`,
                503: `Workbook storage is temporarily unavailable.`,
            },
        });
    }
    /**
     * Set Workbook Review Status
     * @returns WorkbookReviewOut Successful Response
     * @throws ApiError
     */
    public static setWorkbookReviewStatusProjectsProjectIdWorkbooksWorkbookIdReviewStatusPut({
        projectId,
        workbookId,
        requestBody,
    }: {
        projectId: number,
        workbookId: string,
        requestBody: NativeWorkbookReviewStatusIn,
    }): CancelablePromise<WorkbookReviewOut> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/projects/{project_id}/workbooks/{workbook_id}/review-status',
            path: {
                'project_id': projectId,
                'workbook_id': workbookId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Authentication or a valid workbook content capability is required.`,
                403: `The workbook is not available to this user.`,
                404: `The workbook or target scope was not found.`,
                409: `The workbook content or lifecycle state conflicts with this request.`,
                410: `project_archived: the project is archived and workbook access is unavailable.`,
                422: `The workbook request is invalid.`,
                503: `Workbook storage is temporarily unavailable.`,
            },
        });
    }
    /**
     * Set Workbook Verified Rows
     * @returns WorkbookReviewOut Successful Response
     * @throws ApiError
     */
    public static setWorkbookVerifiedRowsProjectsProjectIdWorkbooksWorkbookIdVerifiedRowsPut({
        projectId,
        workbookId,
        requestBody,
    }: {
        projectId: number,
        workbookId: string,
        requestBody: WorkbookVerifiedRowsIn,
    }): CancelablePromise<WorkbookReviewOut> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/projects/{project_id}/workbooks/{workbook_id}/verified-rows',
            path: {
                'project_id': projectId,
                'workbook_id': workbookId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Authentication or a valid workbook content capability is required.`,
                403: `The workbook is not available to this user.`,
                404: `The workbook or target scope was not found.`,
                409: `The workbook content or lifecycle state conflicts with this request.`,
                410: `project_archived: the project is archived and workbook access is unavailable.`,
                422: `The workbook request is invalid.`,
                503: `Workbook storage is temporarily unavailable.`,
            },
        });
    }
}
